import { MondayApiQueryInstance } from "@services/monday/monday-service-ts";
import useSWR from "swr";
/**
 * Custom hook for fetching and managing item name
 */

const fetcher = async (boardId: number | undefined) => {
  const response = await MondayApiQueryInstance.getBoardName(boardId!);
  return response;
};
export const useItemName = (boardId: number | undefined) => {
  const { data, isLoading, error } = useSWR(
    boardId ? `board:${boardId}:name` : null,
    () => fetcher(boardId),
    {
      revalidateOnMount: true,
    },
  );

  return {
    boardName: data,
    isLoading,
    error,
  };
};

export default useItemName;
